module.exports = __webpack_public_path__ + "img/tema-3-6.9e9cf5ee.svg";